import React, { Component } from 'react';

var apiKey = '2d721938f952e9da2ee539748cd0c3319a73d85ca9894eb1955629bafe79dae5';

class CryptoCompareView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        P: 0,
      },
    };
  }

  componentDidMount() {
    var ccStreamer = new WebSocket(
      'wss://streamer.cryptocompare.com/v2?api_key=' + apiKey
    );
    ccStreamer.onopen = function onStreamOpen() {
      var subRequest = {
        action: 'SubAdd',
        subs: ['0~Coinbase~BTC~USD'],
      };
      ccStreamer.send(JSON.stringify(subRequest));
    };

    ccStreamer.onmessage = (message) => {
      var message = JSON.parse(event.data);
      this.setState({ data: message });
      console.log(message);
    };
  }

  render() {
    return <div>{this.state.data.P}</div>;
  }
}
export default CryptoCompareView;
